export const INITIALIZE = "INITIALIZE";
export const SET_LOCALE = "SET_LOCALE";
export const SET_LOCALI = "SET_LOCALI";
